import React from "react";
import "./App.scss";
import RouterWrapper from "./routes";
import { AuthProvider } from "./routes/middleware";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <RouterWrapper />
      </AuthProvider>
    </div>
  );
}

export default App;
